module.exports = __webpack_public_path__ + "assets/3.09b23f59.png";